import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';
import { TokenStorageService } from './token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class PropositionService {
  baseUrl = environment.baseUrl;
  
  constructor(
    private router: Router, 
    private http: HttpClient, 
    private tokenStorage: TokenStorageService
  ) { }

  getPropositionsList$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.get<any>(url + 'list?uuid=' + uuid);
  }

  getProposition$(proposition_id: number ,uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.get<any>(url + '?proposition_id=' + proposition_id + '&uuid=' + uuid);
  }

  addProposition$(uuid: string, propositionInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.post<any>(url + '?uuid=' + uuid, propositionInfo, httpOptions);
  }

  updateProposition$(uuid: string, propositionInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.put<any>(url + '?uuid=' + uuid, propositionInfo, httpOptions);
  }

  getSubmissionPropositions$(uuid: string, submissionId: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.proposition}`;
    return this.http.get<any>(url + 'submission/' + submissionId + '?uuid=' + uuid);
  }

  exportPropositionPdf$(uuid: string, propositionId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.post<any>(url + propositionId + '/export/pdf?uuid=' + uuid, {observe: 'response', responseType: 'blob'});
  }

  exportPropositionPrint$(uuid: string, propositionId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.post<any>(url + propositionId + '/export/html?uuid=' + uuid, httpOptions);
  }

  exportPropositionEmail$(uuid: string, propositionId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.post<any>(url + propositionId + '/export/email?uuid=' + uuid, httpOptions);
  }

  duplicateProposition$(uuid: string, propositionId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.post<any>(url + propositionId + '/copy?uuid=' + uuid, httpOptions);
  }

  deleteProposition$(uuid: string, propositionInfo: any[] ): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.proposition}`;
    return this.http.put<any>(url  + '?uuid=' + uuid, propositionInfo, httpOptions);
  }
}